export { initDataDogRUM, addSMSDataDogUserAction } from './lib/rum'
export { initDataDogLogging } from './lib/logs'
export { getDatadogEnvironmentFromURL } from './lib/utils'

export * from './lib/types'
